import development from "../../Assets/coverImage/development.png";
import { BR, ParagraphText } from "../../Styles/StyleComponent";
import { CoverImage } from "../helper/CoverImage";
import { WebDevelopment } from "../../Assets/ServicesIcon";
import { ServiceContainer } from "./ServiceContainer";
import BackgroundContainer from "../../utils/BackgroundContainer";
import { useContext } from "react";
import { GlobalData } from "../../contextapi/ContextProvider";

export const WebAppDevelopment = () => {

  let {
    allpagesCollection
    } = useContext(GlobalData);


  const webDevelopment = {
    title: allpagesCollection.service_3_title,
    image: allpagesCollection.service_3_image,

    description: (
      <ParagraphText color="#000">

<p dangerouslySetInnerHTML={{ __html: allpagesCollection.service_3_description }} ></p>
      </ParagraphText>
    ),
    type: "Features",
    feature_title : "Key Attributes of Effective Web Application Development",
    features:
      "Customized Solutions,Cutting-Edge Technology,Agile Development,Robust Security,Responsive Design,Scalability,Integration Capabilities,User-Centric Approach,Maintenance and Support",
  };


  return (
    <>
      {/* <CoverImage
        image={development}
        path="web_application_development"
        type="services"
      /> */}

      <BackgroundContainer title={''} description={''} > 
      
      <ServiceContainer services={webDevelopment} title={'Web Application development'} subdescription={`Use dynamic web applications to grow your company. Our skilled developers create dependable, responsive web solutions that improve your online visibility, optimize workflows, and successfully engage your audience. `}  />

      </BackgroundContainer>
    </>
  );
};
